exports = module.exports = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".arrow-forward[data-v-d212983e] path {\n  fill: #FFFFFF;\n}\n", ""]);
